<div class="row page-title">
  <span>{{ localizationConstants.REMINDERS_ADMIN_PAGE_TITLE | translate }}</span>
</div>
<div
  id="tabs"
  class="tabs row center">
  <div class="container col-12 col-lg-8">
    <ul class="c-tab__group">
      <li
        id="tab-status"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.ADMIN_REMINDER_LIST_CHILD_COUNTRY]"
        [routerLinkActive]="['active']">
        {{ localizationConstants.REMINDERS_BY_COUNTRY | translate }}
      </li>
      <li
        id="tab-history"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.ADMIN_REMINDER_LIST_CHILD_COMPANY]"
        [routerLinkActive]="['active']">
        {{ localizationConstants.REMINDERS_BY_COMPANY | translate }}
      </li>
    </ul>
  </div>
</div>
<div
  id="lists"
  class="row u-mb-2">
  <div class="col-12">
    <router-outlet></router-outlet>
  </div>
</div>
